export default {"src":"/_next/static/media/maggie-rounded.d08beb74.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};